import(/* webpackMode: "eager" */ "/Users/gabriel.machado/Documents/zapi-lp/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/Users/gabriel.machado/Documents/zapi-lp/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gabriel.machado/Documents/zapi-lp/src/components/tracking/DeferredTracking.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gabriel.machado/Documents/zapi-lp/src/components/tracking/TrafficTracking.tsx");
